import { message } from 'ant-design-vue'

/** 處理提示訊息通知框 */
export const useMessage = () => {
  /**
   * 開啟短暫 message 提示。
   * @remarks callback 會在 message 自動消失後才執行，常用於顯示成功提示後再導頁或關閉當前流程。
   */
  const openMessage = (
    type: 'success' | 'error' | 'warning' | 'info' | 'loading',
    content: string,
    options: {
      customClass?: string
      duration?: number
      key?: string
    } = {},
    callback?: () => void
  ) => {
    // key 預設用 content：同樣的訊息內容共用同一個 key，antd message 遇到相同 key 會更新既有提示而非疊加新的
    const { customClass = '', duration = 3, key = content } = options

    const config = {
      content,
      class: customClass,
      duration,
      key
    }

    message[type](config)

    // callback 與提示停留時間綁在一起，避免還沒看完提示就先跳頁
    if (duration) {
      setTimeout(() => {
        callback && callback()
      }, duration * 1000)
    }
  }

  return {
    openMessage
  }
}
